import { Badge, Col, Menu, Row, Spin, Typography } from "antd";
import React, { useEffect, useMemo, useState } from "react";
import "./Css/Layout.css";
import type { MenuProps } from "antd";
import useNavigationMenu from "src/hook/useNavigationMenu";
import { profileStore } from "src/stores/profile-store";

import { Menu as ProfileMenusProps } from "src/entity/profile/profile.entity";
import { MenuRootPathEnum, UnGroupThirdLevelMenuEnum } from "src/entity/common/menus-enum.enum";
import { useShallow } from "zustand/react/shallow";
import { RiContractLine } from "react-icons/ri";
import { AiOutlineFlag } from "react-icons/ai";
import { BsFileEarmarkMedical } from "react-icons/bs";
import { FiTruck } from "react-icons/fi";
import { BiBarChartAlt } from "react-icons/bi";
import { FiActivity } from "react-icons/fi";
import { RiTodoLine } from "react-icons/ri";
import { SettingOutlined } from "@ant-design/icons";
import _, { uniqBy, get, cloneDeep } from "lodash";
import { Link, useLocation } from "react-router-dom";
import { myTasksStore } from "src/stores/my-tasks-store";

type MenuItem = Required<MenuProps>["items"][number];
const { Text } = Typography;
interface CustomMenuProps extends MenuProps {
  collapsed?: boolean;
}

const CustomMenu: React.FC<CustomMenuProps> = ({ collapsed }) => {
  const location = useLocation();

  const profile = profileStore(useShallow((state) => state.profile));
  const loadingMyTask = myTasksStore(useShallow((state) => state.loading));
  const mytasks = myTasksStore(useShallow((state) => state.data));

  const totalTasks = useMemo(() => {
    if (!mytasks || !mytasks?.totalTasks) return 0;
    const allowedCompany = ["TPE", "TPC-RY"];
    const isAllowedCompany = allowedCompany.includes(String(profile?.activeCompany?.companyName));
    const total = Object.entries(mytasks.totalTasks).reduce((acc, [key, value]) => {
      if (key === "others" && !isAllowedCompany) return acc;
      return acc + (value || 0);
    }, 0);

    return total;
  }, [mytasks?.totalTasks]);
  const [mappedMenus, setMappedMenus] = useState<MenuItem[]>([]);
  const [vocsChildrenMenu, setVocsChildrenMenu] = useState<any[]>([]);

  const [reRender, setreRender] = useState(false);

  const { current, activeMenu, setActiveMenu } = useNavigationMenu();

  useEffect(() => {
    if (location.pathname) {
      setTimeout(() => {
        setreRender(!reRender);
      }, 500);
    }
  }, [location.pathname]);

  const sortMenusBySortKey = (originMenus: ProfileMenusProps[]) => {
    const sortRecursively = (menuArray: any[]): any => {
      return menuArray
        .map((menu) => ({
          ...menu,
          children: menu.children?.length > 0 ? sortRecursively(menu.children) : [],
        }))
        .sort((a, b) => a.sortKey - b.sortKey);
    };
    return sortRecursively(originMenus);
  };

  const getMenuIcons = (item: ProfileMenusProps) => {
    switch (item.path) {
      case MenuRootPathEnum.MY_TASK:
        return <RiTodoLine />;
      case MenuRootPathEnum.VOCS_INVENTORY:
        return <RiContractLine />;
      case MenuRootPathEnum.PRODUCTION:
        return <FiTruck />;
      case MenuRootPathEnum.TARGET:
        return <AiOutlineFlag />;
      case MenuRootPathEnum.REPORT:
        return <BsFileEarmarkMedical />;
      case MenuRootPathEnum.DASHBOARD:
        return <BiBarChartAlt />;
      case MenuRootPathEnum.STATUS:
        return <FiActivity />;
      case MenuRootPathEnum.SETTING:
        return <SettingOutlined />;
      default:
        return <SettingOutlined />;
    }
  };
  // console.log("totalTasks :: ", totalTasks);
  const parseToAntMenuItems = (originMenus: ProfileMenusProps[]): MenuItem[] => {
    const newListMenus = originMenus.map((item) => {
      // console.log("First ITem : ", item);
      return {
        key: `${item.path}`,
        label: (
          <Link to={item.path}>
            {item.path === "/my-task" ? (
              <Row className="w-full h-full">
                {item.menuName}
                {loadingMyTask ? (
                  <Spin />
                ) : (
                  <>
                    {totalTasks ? (
                      <Badge className="bg-red-500 pl-2 pr-2 h-5 rounded-xl text-center flex items-center justify-center">
                        <Text className="text-white text-xs">{totalTasks}</Text>
                      </Badge>
                    ) : (
                      <></>
                    )}
                  </>
                )}
              </Row>
            ) : (
              <Col className="w-full h-full">{item.menuName}</Col>
            )}
          </Link>
        ),
        icon: getMenuIcons(item),
        children:
          item.children?.length <= 0
            ? null
            : item.children.map((second) => {
                // console.log("Second Level : ", second);
                const isNoneChild = second.children?.length <= 0;
                return {
                  key: `${second.path}`,
                  label: isNoneChild ? <Link to={second.path}>{second.menuName}</Link> : second.menuName,
                  children: isNoneChild
                    ? null
                    : second.path.includes("/vocs-inventory/others") ||
                        (uniqBy(second.children, "group").length === 1 &&
                          uniqBy(second.children, "group")[0].group === UnGroupThirdLevelMenuEnum.CALCULATION)
                      ? second.children.map((thirdLevelUngroup) => {
                          return {
                            key: `${thirdLevelUngroup.path}`,
                            label: <Link to={thirdLevelUngroup.path}>{thirdLevelUngroup.menuName}</Link>,
                          };
                        })
                      : uniqBy(second.children, "group").map((group, groupIndex) => {
                          const listThridMenus = second.children.filter((secondFilt) => secondFilt.group === group.group);
                          return {
                            key: `group-${second.menuName}-${groupIndex}`,
                            label: group.group,
                            type: "group",
                            children: listThridMenus.map((thirdLevel) => {
                              return {
                                key: `${thirdLevel.path}`,
                                label: (
                                  <Link to={thirdLevel.path}>
                                    {thirdLevel.menuName == "Government Report" ? "รายงานราชการ" : thirdLevel.menuName}
                                  </Link>
                                ),
                              };
                            }),
                          };
                        }),
                };
              }),
      };
    });
    return newListMenus;
  };

  useEffect(() => {
    if (profile?.menus && profile.menus.length > 0) {
      const sortOriginMenus: ProfileMenusProps[] = sortMenusBySortKey(profile.menus);
      // Hide: Dashboard Menu
      const hideSomeMenu = sortOriginMenus.filter((item) => item.menuName !== "Dashboard");
      // Hide: Transportation & Marketing -> Report Chemical
      hideSomeMenu.forEach((item) => {
        if (item.path === "/vocs-inventory") {
          item.children.forEach((subItem) => {
            if (subItem.path === "/vocs-inventory/transportation-and-marketing") {
              subItem.children = subItem.children.filter(
                (thridItem) => thridItem.path !== "/vocs-inventory/transportation-and-marketing/report-chemical-volume",
              );
            }
          });
        }

        // Hide Setting Job, Hide Setting History
        // if (item.path === "/setting") {
        //   item.children = item.children.filter((subItem) => !["/setting/job", "/setting/history"].includes(subItem.path));
        // }
      });
      const newMappedMenus = parseToAntMenuItems(hideSomeMenu);
      newMappedMenus.forEach((item: any) => {
        if (item?.key === "/vocs-inventory") {
          setVocsChildrenMenu(get(item, "children") as any);
          item.children = [];
        }
      });
      setMappedMenus(newMappedMenus);
    }
  }, [profile, totalTasks, loadingMyTask]);

  const getVocMenus = useMemo(() => {
    const baseMenu: any = cloneDeep(mappedMenus);
    // console.log("baseMenu[1] : ", baseMenu);
    const tmpChildrenMenus = cloneDeep(vocsChildrenMenu);
    if (!baseMenu?.length) return [];

    if (!current || !current.includes("/vocs-inventory")) {
      baseMenu[1].children = [];
    } else {
      // /vocs-inventory/combustion/setup-fuel-volume
      const extractActivePath = current.split("/");
      const activePath = extractActivePath[2];
      const findSlotChildren = tmpChildrenMenus.find((vocsChildren) => vocsChildren.key.includes(activePath));
      baseMenu[1].children = [findSlotChildren];

      const parse = current.split("/");
      const fullPath = parse.slice(0, parse.length - 1).join("/");

      setActiveMenu(["/vocs-inventory", fullPath]);
    }
    // console.log("Final base menu : ", baseMenu);
    return baseMenu;
  }, [profile?.menus, current, mappedMenus, vocsChildrenMenu, collapsed]);

  const onClick: MenuProps["onClick"] = (e) => {
    // console.log("click ", e);
  };
  // console.log("Active Menu & current : ", { activeMenu, current });

  return (
    <Menu
      id="sider-menu"
      onClick={onClick}
      inlineIndent={12}
      selectedKeys={[current]}
      openKeys={activeMenu}
      // defaultOpenKeys={defaultOpenMenu} // doesn't work
      onOpenChange={(e) => setActiveMenu(e)}
      mode="inline"
      items={getVocMenus}
      className="menu-height"
    />
  );
};

export default CustomMenu;
